<template>
  <div
    class="talent-detail-container"
  >
    <div class="talent-details">
      <!--  人才信息部分  -->
      <div v-loading="scholarInfoLoading">
        <talent-info :talent-data="talentData" />
      </div>
      <!--  分割线  -->
      <div style="border-bottom: 1px dashed #eeeeee; margin: 6px 0 20px"></div>
      <!--  选择展示项  -->
      <div class="flex">
        <div
          v-if="talentData.citationReportVisible"
          :class="selectType === '学术综合能力' ? 'selectItemStyle' : 'itemStyle'"
          @click="changeType('学术综合能力')"
        >
          学术综合能力
        </div>
        <div
          :class="selectType === '个人资料' ? 'selectItemStyle' : 'itemStyle'"
          @click="changeType('个人资料')"
        >
          个人资料
        </div>
        <div
          :class="selectType === '科研成果' ? 'selectItemStyle' : 'itemStyle'"
          @click="changeType('科研成果')"
        >
          科研成果
        </div>
        <div
          :class="selectType === '合作关系' ? 'selectItemStyle' : 'itemStyle'"
          @click="changeType('合作关系')"
        >
          合作关系
        </div>
        <div
          :class="selectType === '前沿分析' ? 'selectItemStyle' : 'itemStyle'"
          @click="changeType('前沿分析')"
        >
          前沿分析
        </div>
      </div>
      <!--  具体展示项(不同类型展示项不同根据selectType区分)  -->
      <div>
        <div v-if="selectType === '学术综合能力'">
          <talent-cites ref="talentCites" :scholar-id="googleId" :cites-per-year="citesPerYear" />
        </div>
        <div v-show="selectType === '个人资料'" class="personal-infor">
          <div class="flex select-p-view">
            <p
              class="pointer"
              :class="{ active: activePersonalInfor === tab }"
              v-for="(tab, index) in personalInforTabs"
              :key="index"
              @click="() => (activePersonalInfor = tab)"
            >
              {{ tab }}
            </p>
          </div>

          <talent-info-dialog
            v-show="activePersonalInfor === '个人资料'"
            :talent-data="talentData"
            ref="talentInfoDialog"
            v-loading="scholarInfoLoading"
          />

          <ai-personal-information
            v-show="activePersonalInfor === 'AI检索'"
            :scholar-name="talentData.scholarVO?.scholarName"
            :scholar-org="talentData.scholarVO?.scholarOrg"
            :scholarId="scholarId"
          />
        </div>

        <div v-if="selectType === '科研成果'">
          <achievement-list :scholar-id="scholarId" />
        </div>
        <div v-if="selectType === '合作关系'">
          <cooperation-view :scholar-id="scholarId" />
        </div>
        <div v-if="selectType === '前沿分析'">
          <analysis-view :scholar-id="scholarId" :field-tow-e-names="talentData.scholarVO.fields" />
        </div>
      </div>
      <!--  人才详情资料弹窗  -->
    </div>
    <!-- 付费弹窗 -->
    <paymentDialog ref="scholarDetailPayment" payType="人才详情"  />
  </div>
</template>

<script>
import TalentInfo from '@/views/details/comps/talentInfo.vue';
import TalentInfoDialog from '@/views/details/comps/talentInfoDialog.vue';
import AchievementList from '@/views/details/comps/achievementList.vue';
import TalentCites from '@/views/details/comps/talentCites.vue';
import CooperationView from '@/views/details/comps/cooperationView.vue';
import AnalysisView from '@/views/details/comps/analysisView.vue';
import { getScholarDetailApi } from '@/api/details';
import aiPersonalInformation from '@/views/details/comps/aiPersonalInformation.vue';
import paymentDialog from '@/components/PaymentDialog.vue';

export default {
  name: 'talentDetail',
  components: {
    AnalysisView,
    CooperationView,
    TalentCites,
    AchievementList,
    TalentInfoDialog,
    TalentInfo,
    aiPersonalInformation,
    paymentDialog
  },
  data() {
    return {
      isDisabled: false, // 访问次数是否已达上限
      scholarId: '',
      googleId: '',
      scholarInfoLoading: false,
      citesPerYear: null,
      selectType: '学术综合能力',
      talentData: {},

      activePersonalInfor: 'AI检索',
      personalInforTabs: ['AI检索', '个人资料'],
    };
  },
  created() {
    this.scholarId = this.$route.query.id;
    this.getScholarDetail();
  },
  methods: {
    /**
     * 获取人才详情
     */
    getScholarDetail() {
      this.scholarInfoLoading = true;
      getScholarDetailApi(this.scholarId)
        .then((res) => {
          this.talentData = res.data;
          this.citesPerYear = res.data.citesPerYear || [];
          this.scholarInfoLoading = false;
          if (this.talentData.citationReportVisible) {
            this.selectType = '学术综合能力';
            this.googleId = this.talentData.scholarVO.googleId;
          } else {
            this.selectType = '个人资料';
          }
        })
        .catch(error => {
          // 付费弹窗
          if (error.response?.status === 429) {
            this.scholarInfoLoading = false;
            let talentCites = this.$refs.talentCites;
            talentCites.$refs.citesBar.loading = false;
            this.isDisabled = true;
            this.confirmPay();
            return false;
          }
          // 其他错误处理
          else {
            this.$message.error('服务器出错啦，请稍后重试');
          }
          this.scholarInfoLoading = false;
        });
    },

    // 是否购买 对话框
    confirmPay() {
      this.$confirm('您的访问次数已达上限，如需继续访问可购买次数，是否立即购买？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '立即购买',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs.scholarDetailPayment.open();
      }).catch(() => {
      });
    },

    /**
     * 人才详情资料弹窗
     */
    showTalentInfo() {
      this.$refs.talentInfoDialog.showDialog();
    },
    /**
     * 切换查看项类型
     * 类型
     * @param type
     */
    changeType(type) {
      if (this.isDisabled) {
        return false;
      }
      this.selectType = type;
    },
  },
};
</script>

<style scoped lang="less">
.talent-detail-container {
  width: 1400px;
  margin: 0 auto;
}

.itemStyle {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  color: #666666;
  margin-right: 20px;
}

.selectItemStyle {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  color: #1241C9;
  margin-right: 20px;
}

.infoPosition {
  padding: 10px 0;
  background: #f2f4f7;
  font-size: 14px;
  span {
    color: #999999;
  }

  a {
    color: #999;
    &:hover {
      color: #1241C9;
    }
  }
}

.lookInfo {
  margin: 14px 122px;
  cursor: pointer;
  width: 108px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef3f8;
  border-radius: 4px;
  font-size: 12px;
  color: #497ea6;
}

.talent-details {
  padding: 23px 46px;
}

.personal-infor {
  padding-top: 13px;

  .select-p-view p {
    font-size: 14px;
    color: #333333;
    padding: 7px 0;
    width: 100px;
    text-align: center;
  }

  .select-p-view .active {
    font-size: 14px;
    color: #1241C9;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid rgb(37, 61, 154);
  }
}
</style>
